import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { IcoInfo16 } from '@onefootprint/icons';
import Tooltip from '../tooltip';
export type LabelTooltipProps = {
  text: string;
  triggerAriaLabel?: string;
  iconComponent?: Icon;
};
export type LabelProps = {
  children: string;
  hasError?: boolean;
  htmlFor?: string;
  id?: string;
  size?: 'default' | 'compact';
  tooltip?: LabelTooltipProps;
};
const Label = t0 => {
  const $ = _c(11);
  const {
    children,
    hasError: t1,
    htmlFor,
    id,
    size: t2,
    tooltip: t3
  } = t0;
  const hasError = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  const tooltip = t3 === undefined ? undefined : t3;
  let t4;
  if ($[0] !== children || $[1] !== hasError || $[2] !== htmlFor || $[3] !== id || $[4] !== size) {
    t4 = <label className="fp-label fp-custom-appearance" data-has-error={hasError} data-size={size} htmlFor={htmlFor} id={id}>{children}</label>;
    $[0] = children;
    $[1] = hasError;
    $[2] = htmlFor;
    $[3] = id;
    $[4] = size;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== tooltip) {
    t5 = tooltip && <Tooltip disabled={!tooltip.text} content={tooltip.text}><button type="button" aria-label={tooltip?.triggerAriaLabel ?? tooltip?.text} className="bg-none border-none m-0 pt-0.5 px-0 pb-0">{tooltip?.iconComponent ? <tooltip.iconComponent /> : <IcoInfo16 />}</button></Tooltip>;
    $[6] = tooltip;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="mb-2 flex flex-row justify-start gap-1">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default Label;